export default {
  "pl": {
    "button": {
      "actions": {
        "add": "Dodaj",
        "cancel": "Anuluj",
        "create": "Utwórz",
        "delete": "Usuń",
        "edit": "Edytuj",
        "hide": "Ukryj",
        "loading": "Wczytywanie",
        "reset": "Zresetuj",
        "save_changes": "Zapisz zmiany",
        "save_message": "Zapisz wiadomość",
        "saving": "Zapisywanie",
        "share": "Dzielić",
        "uploadingDocuments": "Przesyłanie dokumentów",
        "yes": "Tak"
      }
    }
  }
}
